const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_PerformanceTeam":
      return { ...state, Team: payload };
    case "SAVE_PerformanceTeamPrev":
      return { ...state, TeamPrev: payload };
    case "SAVE_PerformanceReport":
      return { ...state, Report: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
